var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAviSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.0455 23.0953C5.0455 23.0953 1.14764 23.3389 1.00156 22.9004C0.855488 22.4619 10.9892 1.56175 11.2815 1.22072C11.5737 0.879693 13.5225 0.977167 13.7174 1.22072C13.9123 1.46428 15.1302 4.09511 15.1302 4.09511L23.997 22.803C23.997 22.803 24.0457 23.0953 23.7534 23.0953H20.002L12.5969 7.79771H12.2071L5.0455 23.0953Z",
    stroke: "#1998F0",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72497 22.4619C7.77369 22.2671 9.08908 19.7824 9.08908 19.7824H15.9097C16.3156 20.6594 17.0302 22.1209 17.1763 22.4619C17.3225 22.803 16.9815 23.0953 16.8353 23.0953C13.9284 23.144 8.20241 23.2122 7.96856 23.0953C7.73471 22.9784 7.67625 22.6568 7.72497 22.4619Z",
    stroke: "#1998F0",
    strokeWidth: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviSync);
export default __webpack_public_path__ + "static/media/aviSync.c4d285b96de528469f635d3f6c220452.svg";
export { ForwardRef as ReactComponent };